import GetEventsListRequestModelBase from '../_generated/modelBases/get-events-list-request-model-base';

export default class GetEventsListRequestModel extends GetEventsListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
